<template>
  <div class="help padding_top">
    <p><strong>【步骤】：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【账号管理】</span>
    </p>
    <p> 1. 在编辑页面中,可对“基本信息/账号信息/职业信息/专业科室/专业资质/账户信息/荣誉成就/服务类型/简述”进行编辑
    </p>
    <p>
      2. 在需要编辑的信息框内修改信息，点击对应项的【保存】按钮，进行信息更新
    </p>
    <img src="../../../assets/doctorImg/editInfo.png" alt="" >
  </div>

</template>

<script>
export default {
  name: "editInfo",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
